import { isNil } from "lodash";

import { AGENTS } from "@/react/features/vcc/constants";
import { AllApiGroupValues } from "@/react/features/vcc/types/agents";
import { agentsPath } from "@/react/features/vcc/urls";
import { HttpMethods } from "@/react/http";
import { customerBaseApi } from "@/react/services/api";

export const { useGetAgentsQuery, useUpdateAgentsMutation } =
  customerBaseApi.injectEndpoints({
    reducerPath: "agentsApi",
    endpoints: (build) => ({
      getAgents: build.query({
        query: ({ tenantName }) => ({
          url: agentsPath(tenantName, AllApiGroupValues),
          method: HttpMethods.GET,
        }),
        providesTags: [AGENTS],
        transformResponse: (response) =>
          response?.filter((agent) => !isNil(agent.sso)),
      }),
      updateAgents: build.mutation({
        query: ({ tenantName, agents }) => ({
          url: agentsPath(tenantName, AllApiGroupValues),
          method: HttpMethods.PUT,
          body: agents,
        }),
        invalidatesTags: [AGENTS],
      }),
    }),
  });
